import { Button, ButtonVariant, ContentNode } from '@dreryk/react-components';

import { PurchasePackageModalOpener } from './PurchasePackageModal.opener';

type PurchasePackageModalButtonProps = {
   readonly label: ContentNode;
   readonly modalTitle: ContentNode;
};

export const PurchasePackageModalButton = (props: PurchasePackageModalButtonProps): JSX.Element => {
   return (
      <PurchasePackageModalOpener title={props.modalTitle}>
         {({ openModal }) => (
            <Button
               testId={'purchasePackageButton'}
               variant={ButtonVariant.SECONDARY}
               label={props.label}
               onClick={openModal}
            />
         )}
      </PurchasePackageModalOpener>
   );
};
